import {
  GET_REASON_FOR_BLOCK_DATE,
  GET_REASON_FOR_BLOCK_DATE_SUCCESS,
  GET_REASON_FOR_BLOCK_DATE_ERROR,
  GET_REASON_FOR_BLOCK_DATE_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetReasonForBlockDate = (state = initialState, action) => {
  switch (action.type) {
    case GET_REASON_FOR_BLOCK_DATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_REASON_FOR_BLOCK_DATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_REASON_FOR_BLOCK_DATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_REASON_FOR_BLOCK_DATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetReasonForBlockDate;
